import env from './env';

const config = {
    zoom: 17,
    minStepToSync: 70, // минимальное расстояние через которое отправляем координаты на сервер
    minStepToLoadHexes: 300, // минимальное расстояние через которое догружает гексы
    patterns: {
        'grass': '/img/patterns/grass.webp',
        'forest': '/img/patterns/forest.jpg',
        'swamp': '/img/swamp.jpg',
        'sand': '/img/sand.jpg',
        'lava': '/img/patterns/lava.webp',
        'snow': '/img/patterns/snow.webp',
        'ice': '/img/ice2.jpg',
        'forest_bottom': '/img/patterns/firgrass.png',
        'silver_tiles': '/img/patterns/silver_tiles.webp',
        'golden_tiles': '/img/patterns/golden_tiles.webp',
        'wooden_tiles': '/img/patterns/wooden_tiles.jpg',
        'unknownPattern': '/img/patterns/forest5.jpg',
        'water': '/img/patterns/water2.jpg',
        'steps': '/img/patterns/footprints.jpg',
        'plague': '/img/patterns/plague6.webp',
        'mushrooms': '/img/patterns/mushrooms.webp',
    },
    productionTypes: {
        1: {
            src: '/img/icons/building_statuses/ready.webp',
            scale: 0.4,
            anchor: [0.5, 2.1]
        },
        2: {
            src: '/img/icons/building_statuses/awaiting.webp',
            scale: 0.4,
            anchor: [0.5, 2.1]
        }
    }
};
export default {...config, ...env};
